import { Routes } from '@angular/router';
import { SiaTemplateConfiguratorComponent } from './pages/template-configurator/template-configurator.component';

export const ROUTES: Routes = [
  {
    path: 'web-template-configurator/:guid',
    component: SiaTemplateConfiguratorComponent,
  },
];
